import { deconstructNode } from '~/libs/contentful/helpers'
import { TypeFaqBlockSkeleton, TypeFaqQuestionSkeleton } from '~/types/contentful'
import { Entry } from 'contentful'
import { TopLevelBlock } from '@contentful/rich-text-types'
import { FaqBlock } from '~/components/shared/FaqBlockContainer'
import { Question } from '~/components/shared/FaqBlockContainer/config'

type FaqBlockProps = {
  faqData: Entry<TypeFaqBlockSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
  isGray?: boolean
}

export const IndexFaqBlock = ({ faqData }: FaqBlockProps) => {
  const { title, additionalNotes, image, questions, blockId } = faqData.fields

  const transformedQuestions = questions?.content
    .filter(
      (i: TopLevelBlock) =>
        i.data?.target as Entry<TypeFaqQuestionSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>,
    )
    .map((ele) => {
      const { fields } = deconstructNode(ele) as unknown as TypeFaqQuestionSkeleton

      return {
        question: fields?.question,
        answer: fields?.answer,
      } as unknown as Question
    })

  return (
    <FaqBlock
      title={title}
      image={image}
      questions={transformedQuestions}
      additionalNotes={additionalNotes}
      blockId={blockId}
    />
  )
}
